<div class="image" (click)="imageClicked($event)">
    <img *ngIf="url && !isLoading" [src]="url">
    <div *ngIf="!url && !isLoading" class="no-image">
        imagem não disponível
    </div>
    <div *ngIf="isLoading">
       
    </div>
</div>

<div class="top">&nbsp;</div>
<div class="name">
    <div class="value">{{product.name || product?.productName || '---'}}</div>
</div>
<div class="details">
    <div class="sku line">
        <div class="label">Código do Item:</div>
        <div class="value">{{product.sku}}</div>
    </div>
    <div class="secondary-info">
        <div class="info line">
            <div class="label">Quantidade:</div>
            <div class="value">{{product.quantity | number:'1.0-0':'pt-BR'}}</div>
        </div>
        <div class="info line">
            <div class="label">Tamanho do Pacote:</div>
            <div class="value">{{product.packSize ? (product.packSize | number:'1.0-0':'pt-BR') : '---'}}</div>
        </div>
    </div>
</div>
